import { Center, Loader, Text } from '@mantine/core';

import { ReactorsList } from './ReactorsList';

type ReactorsModalContentProps = {
  data: string[] | undefined;
  isLoading: boolean;
  error: unknown;
};

export const ReactorsModalContent = ({ data, isLoading, error }: ReactorsModalContentProps) => {
  if (isLoading) {
    return (
      <Center py="xl">
        <Loader size="md" />
      </Center>
    );
  }

  if (error) {
    return (
      <Text c="red" size="sm" ta="center" py="md">
        Failed to load reactors
      </Text>
    );
  }

  if (data) {
    return <ReactorsList ids={data} />;
  }

  return null;
};
